/**
 * Regras de obrigatoriedade dos textos alternativos (ALT) das imagens no
 * formulário da notícia — o Volto pinta a "bolinha vermelha" e bloqueia o
 * salvamento para os campos em `schema.required`.
 *
 * O ALT é a exigência de acessibilidade (descreve a imagem para leitores de
 * tela); a legenda é complemento visível e NÃO substitui o ALT — por isso a
 * legenda fica opcional. Regras (só valem quando a imagem existe):
 * - Imagem de destaque (`image`): ALT (`descricaoImagem`) obrigatório.
 * - Imagem de pré-visualização (`preview_image_link`): ALT (`preview_alt_link`)
 *   obrigatório.
 *
 * O backend espelha estas regras no salvamento (subscriber
 * `alt_imagem_obrigatorio.py`).
 */
const NEWS_TYPES = ['News', 'Noticia'];

const hasValue = (v: unknown): boolean =>
  Array.isArray(v) ? v.length > 0 : Boolean(v);

/** Ids dos campos que devem ficar obrigatórios, dado o estado atual do form. */
export function computeImageRequired(
  type: string | undefined,
  formData: Record<string, unknown> = {},
): string[] {
  if (!type || !NEWS_TYPES.includes(type)) return [];
  const required: string[] = [];

  if (hasValue(formData.image)) {
    required.push('descricaoImagem');
  }
  if (hasValue(formData.preview_image_link)) {
    required.push('preview_alt_link');
  }

  return required;
}

/** Devolve o schema com os campos extras marcados como obrigatórios. */
export function mergeRequired(
  schema: { required?: string[]; properties?: Record<string, unknown> } | null,
  extra: string[] = [],
) {
  if (!schema) return schema;
  const known = extra.filter((f) => schema.properties?.[f]);
  if (known.length === 0) return schema;
  const required = schema.required ?? [];
  return { ...schema, required: [...new Set([...required, ...known])] };
}
